import type { TourConfig } from '../../types/tour.types'

// Lead Enrichment — main dashboard. A second tour (lead-enrichment-mapping.tour.ts)
// takes over when the column-mapping modal opens.
const leadEnrichmentTour: TourConfig = {
  id: 'lead-enrichment',
  title: 'Enrich your leads',
  module: 'Enrichment',
  routeName: 'LeadEnrichment',
  order: 6,
  autoStart: true,
  featureFlag: 'enableLeadEnrichment',
  // Active on the dashboard (the two enrichment cards), but NOT while the column-mapping
  // modal is open — that hand-off is covered by lead-enrichment-mapping.tour.ts.
  condition: () =>
    !!document.querySelector('.le-choices') && !document.querySelector('.scm-root'),
  steps: [
    {
      id: 'intro',
      title: 'Turn a plain list into rich leads',
      body: 'Already have a spreadsheet of companies or contacts? Upload it and TAMI fills in the gaps — **verified emails, job titles, phone numbers and company data** — so a bare list becomes something you can actually sell to.',
    },
    {
      id: 'contact',
      target: '.le-choice--contact',
      placement: 'bottom',
      title: 'Already have contacts? Refresh them',
      body: 'Upload a CSV of people and we\'ll return their **current email, job title and phone number**. Click **Upload contact file** (or drop a CSV onto the card) — next you\'ll map your columns to TAMI\'s fields, and we\'ll walk you through that too.',
    },
    {
      id: 'company',
      target: '.le-choice--company',
      placement: 'bottom',
      title: 'Have companies? Match and enrich them',
      body: 'Upload a list of companies and we\'ll match them, then add **deep insights** — e-commerce, shipping, technologies and payment data — and let you **find contacts** for them in the List Builder.',
    },
    {
      id: 'recent',
      target: '[data-tour="le-recent"]',
      placement: 'top',
      title: 'Your results land here',
      body: 'Every enrichment shows up under **Recent Enrichments**. It runs in the background, so you can keep working — then open the report or the new list created from your file, ready to work or export.',
    },
  ],
}

export default leadEnrichmentTour
